<template lang="pug">
  div.fkko-row
    div.item(:class="rowClass + ' ' +(open ? 'open' : 'close')")
      div(
        v-for="(item, i, a) in value"
        :key='i'
        :id="`fkko-parent-${value.parent_id}`"
        v-if="visibleColumns[a]"
        @click.prevent.stop="expand(value)"
      )
        span(v-if="a == 0 && value.has_children").arrow
        span {{ value[visibleColumns[a]] }}
      span(@click.prevent.stop="")
        div.buttons
          button(
            v-if="value.parent_id && userCanCreate && value.code && value.code.endsWith('0') === true && !value.reg_code"
            @click="goToCreate(value)"
          ).row-add
          button(
            v-if="userCanEdit"
            @click="goToEdit(value)"
          ).row-edit
          button(
            v-if="userCanDelete && value.reg_code"
            @click="removeItem(value)"
          ).row-delete
    template(
      v-if="open && childrens"
      v-for="(child, i) in childrens"
    )
      expand-row(
        :rootId="value.parent_id"
        :depth="depth*1 + 1"
        :value="child"
        :visibleColumns="visibleColumns"
        :key="child.id"
        @delete="onDelete"
      )
</template>

<script>
  import { cadastr }             from '../../../api/api-endpoints'
  import expandRow               from './fkko-row.vue'
  import permissionMixin         from '../../../mixins/permission-mixin.js'
  import { LEVEL_CSS_CLASS_MAP } from '../../../config/config'
  
  export default {
    mixins: [permissionMixin],
    data() {
      return {
        open:      false,
        childrens: null
      }
    },
    name:       'expandRow',
    props:      {
      value:          '',
      visibleColumns: '',
      depth:          '',
      rootId:         ''
    },
    components: { expandRow },
    computed:   {
      rowClass() {
        let lvl = +(this.depth || 0)
        return LEVEL_CSS_CLASS_MAP[lvl + 1] || ''
      }
    },
    created() {
      this.subs = this.$emitter.listen('classifier.fkko', this.onMessage)
    },
    destroyed() {
      if (this.subs) {
        this.subs.unsubscribe()
      }
    },
    methods: {
      onMessage(e) {
        console.log(e)
        if (e && e.action === 'reFetchData' && this.value) {
          if (this.open) {
            this.fetchData(this.value.id)
          } else {
            this.childrens = null
          }
        }
      },
      onDelete(value) {
        console.log('onDelete', JSON.stringify(value), JSON.stringify(this.childrens))
        this.childrens = this.childrens.filter(v => v.id !== value.id)
      },
      goToCreate(value) {
        this.$router.push({
                            name:   'classifier.fkko.create',
                            params: {
                              pid:    value.parent_id,
                              rootId: this.rootId || 0
                            },
                            query:  {
                              setFields: JSON.stringify({
                                                          parent_id:    value.id,
                                                          parentIdName: value.name
                                                        })
                            }
                          })
      },
      goToEdit(value) {
        this.$router.push({
                            name:   'classifier.fkko.update',
                            params: {
                              id:     value.id,
                              pid:    this.rootId || 0,
                              rootId: this.rootId || 0
                            }
                          })
      },
      removeItem(value) {
        this.$e.confirmBox().then(() => {
          this.$store.dispatch('deleteModel', {
            url: cadastr.fkkoDelete(value.id)
          }).then(r => {
            this.$e.successBox('Запись успешно удалена')
            this.$emit('delete', value)
          }).catch(erResponse => {
            this.$e.errorBox(erResponse)
          })
        })
      },
      expand(value) {
        this.open = !this.open
        if (value.has_children && !this.childrens) {
          this.fetchData(value.id)
        }
      },
      fetchData(parentId) {
        this.$bar.start()
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: cadastr.fkko({ query: { parent_id: parentId } }),
          params:   {
            disableGlobalError: true
          }
        }).then(response => {
          this.childrens = response.data.data
          this.$bar.finish()
        }).catch(e => {
          this.$bar.finish()
          this.$e.errorBox(e)
        })
      }
    }
  }
</script>
